import React, { Fragment } from "react"
import { Styled } from "theme-ui"
import ExternalLink from '../../components/externalLink'

/**
 * Change the content to add your own bio
 */

const BioContent = () => (
  <Fragment>
    I'm <ExternalLink href="https://www.linkedin.com/in/piyussh">Piyush Dankhra</ExternalLink>
    {` `}
    <br />
    <ExternalLink href="https://www.credly.com/users/piyush-dankhra/badges" title={"Magento Certification"}>Adobe Certified Expert</ExternalLink> - Adobe Commerce Developer / Front-End Developer / Business Practitioner
    <br />
    <ExternalLink href="https://www.credly.com/users/piyush-dankhra/badges" title={"Magento Certification"}>Adobe Subject Matter Expert</ExternalLink> - Adobe Commerce Front End Developer / Business Practitioner
    <br />
    Working on Magento 2 / Hyva
  </Fragment>
)

export default BioContent
